"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryPublicArcGIS = exports.enhanceQueryGeometryWithParcelBounds = void 0;
const { queryFeatures } = require("@esri/arcgis-rest-feature-layer");
// Returns either an IPoint or IMultipoint geometry type given ICoordinatesRequest
const enhanceQueryGeometryWithParcelBounds = (request) => {
    const queryGeometry = {
        x: Number(request.long),
        y: Number(request.lat),
        spatialReference: {
            wkid: 4326,
        },
    };
    if (request.parcelData && request.parcelData.length > 3) {
        // Must have at least 4 points to be valid
        // @ts-ignore
        const queryGeometryToAssign = {
            // @ts-ignore
            points: request.parcelData,
            spatialReference: {
                wkid: 4326,
            },
        };
        // If parcel geo is too big, don't use it for query.
        if (JSON.stringify(request.parcelData).length < 1500) {
            return queryGeometryToAssign;
        }
    }
    return queryGeometry;
};
exports.enhanceQueryGeometryWithParcelBounds = enhanceQueryGeometryWithParcelBounds;
// Executes a generic public query given an ICoordinatesRequest
const queryPublicArcGIS = async (featureLayer, request, outFields, returnGeometry) => {
    const queryGeometry = (0, exports.enhanceQueryGeometryWithParcelBounds)(request);
    return queryFeatures({
        url: featureLayer,
        geometry: queryGeometry,
        geometryType: (queryGeometry === null || queryGeometry === void 0 ? void 0 : queryGeometry.points)
            ? "esriGeometryMultipoint"
            : "esriGeometryPoint",
        spatialRel: "esriSpatialRelIntersects",
        returnGeometry: returnGeometry === true,
        outFields: outFields,
        f: "geojson",
    }).catch((e) => {
        return null;
    });
};
exports.queryPublicArcGIS = queryPublicArcGIS;
//# sourceMappingURL=query.js.map